<template>
    <div>
        <div class="row">
            
                <div v-for="(item, key) in slides_list" @click="setSlide(key)" class=" mb-1 faq-title col-xs-6 col-lg-3 col-md-3 col-sm-4" :key="item.id">
                    <div class="faq-card" :class="{active:item.id == id}">{{item.name}}</div>
                </div>

                
             
        </div>
        <div class="text-center p-md-4 p-sm-1 py-1 p-0">
            <h1>{{cur_title}}</h1>
            {{description}}
        </div>
        <div class="accordion">
            <b-card v-for="(item, index) in questions" no-body class="collapse-header" :key="item.id+'-'+index" >
                <b-card-header header-tag="div" class="p-1  collapse-icon"  role="tab">
                    <span class="collapse-title d-flex align-items-center"  data-toggle="collapse" v-b-toggle="'accordion-'+index">
                        {{item.title}}
                    </span>
                </b-card-header>
                <b-collapse :id="'accordion-'+index">
                    <b-card-body>
                        <b-card-text  v-html="item.text"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>

 


    </div>  



</template>

<script>
import globalSettings from '@/config.js'
import axios from '@/axios'
export default {
  name: 'faq',
  data () {
        return {
            id:null,
            cur_title:null,
            questions:[],
            description:null,
            slides_list:[],
            quest_list:{},
            
        }
  },
  methods:{
      
        setSlide:  function (id) {
           console.log(id)
            this.id = this.slides_list[id].id
            this.cur_title =this.slides_list[id].name
            this.description = this.slides_list[id].description
            if(this.quest_list[this.slides_list[id].id] !== undefined){ //если данные есть то просто берем их
                 this.questions = this.quest_list[this.slides_list[id].id]    
            }else{// если данных нет то запрашиваем
                axios.get(globalSettings.api_url + 'faq/'+ this.id +'/questions-list?lang='+this.$i18n.locale)
                .then(response => {
                   this.questions = response.data
                   this.quest_list[this.slides_list[id].id] = response.data
                   
                   this.show = true; 
                })
            }
        },
        
        setSlides:  function () {
            axios.get(globalSettings.api_url + 'faq/topics-list?lang='+this.$i18n.locale)
            .then(response => {
                this.slides_list = response.data
                this.setSlide(0)
            }) 
        },
          
 },
  
    mounted() {
      this.setSlides()
    },
}
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
        opacity: 0
    }
    .faq-card{
            min-height: 50px;
            border: 2px solid #727E8C;
            padding: 20px;
            text-align: center;
            cursor: pointer;
            
    }
    .faq-card.active{
            min-height: 50px;
            color:#5A8DEE;
            font-weight: bold;
            border: 2px solid #5A8DEE;
            
            
    }
</style>

	